//check for --, 0, null, undefined values
//@val seen in defined array of possible values return false, to bind otherwise data
export const numValChk = (val: string | number) => {
	const checkFor: Array<any> = ["--", 0, null, undefined, "0.00", 0.0, "0.0"];
	return checkFor.indexOf(val) >= 0 ? false : true;
};
